import React from 'react';
export const Present = () => (
  <svg width="201px" height="161px" viewBox="0 0 201 161" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1302.000000, -743.000000)">
        <path
          d="M1450.56983,897 L1354.43037,897 L1302.50857,844.961239 C1301.83048,844.281624 1301.83048,843.169606 1302.50857,842.489991 L1401.26703,743.509056 C1401.946,742.830315 1403.05466,742.830315 1403.73275,743.509056 L1502.49208,842.489991 C1503.16931,843.169606 1503.16931,844.281624 1502.49208,844.961239 L1450.56983,897 Z"
          fill="#F3F4F6"
          fillRule="nonzero"
        />
        <path
          d="M1439,900.000478 C1439,902.209683 1429.59741,904 1417.99949,904 C1406.40158,904 1397,902.209683 1397,900.000478 C1397,897.791273 1406.40158,896 1417.99949,896 C1429.59741,896 1439,897.791273 1439,900.000478"
          fill="#D0D7DA"
        />
        <g transform="translate(1393.000000, 857.000000)">
          <path
            d="M0.9702,16.0258 L0.9702,33.2198 C0.9702,37.8008 4.6832,41.5148 9.2652,41.5148 L40.3712,41.5148 C44.9522,41.5148 48.6662,37.8008 48.6662,33.2198 L48.6662,0.0408 L0.9702,0.0408 L0.9702,9.0748"
            fill="#FFFFFF"
          />
          <path
            d="M0.9702,16.0258 L0.9702,33.2198 C0.9702,37.8008 4.6832,41.5148 9.2652,41.5148 L40.3712,41.5148 C44.9522,41.5148 48.6662,37.8008 48.6662,33.2198 L48.6662,0.0408 L0.9702,0.0408 L0.9702,9.0748"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          d="M1441,890.373734 C1441,894.597412 1434,897 1434,897 L1434,859 L1441,859 L1441,890.373734 Z"
          fill="#F2F3F3"
        />
        <path
          d="M1447,896 L1479,896"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1391,896 L1337,896"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1327,896 L1319,896"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M1397,821 L1397,823" stroke="#D62793" strokeLinecap="round" />
        <path d="M1397,827 L1397,829" stroke="#D62793" strokeLinecap="round" />
        <path d="M1401,825 L1399,825" stroke="#D62793" strokeLinecap="round" />
        <path d="M1395,825 L1393,825" stroke="#D62793" strokeLinecap="round" />
        <path d="M1438,819 L1438,821" stroke="#AA81F7" strokeLinecap="round" />
        <path d="M1438,825 L1438,827" stroke="#AA81F7" strokeLinecap="round" />
        <path d="M1442,823 L1440,823" stroke="#AA81F7" strokeLinecap="round" />
        <path d="M1436,823 L1434,823" stroke="#AA81F7" strokeLinecap="round" />
        <path
          d="M1420,814.500494 C1420,815.328284 1419.32806,816 1418.5,816 C1417.67194,816 1417,815.328284 1417,814.500494 C1417,813.671716 1417.67194,813 1418.5,813 C1419.32806,813 1420,813.671716 1420,814.500494"
          fill="#F5C400"
        />
        <path
          d="M1458,848.499506 C1458,849.328284 1457.32905,850 1456.5,850 C1455.67194,850 1455,849.328284 1455,848.499506 C1455,847.671716 1455.67194,847 1456.5,847 C1457.32905,847 1458,847.671716 1458,848.499506"
          fill="#0B9CE5"
        />
        <g transform="translate(1416.000000, 842.000000)">
          <path
            d="M11.5078,1.2064 C10.2288,0.3154 4.8128,1.8544 2.4878,5.1934 C0.1638,8.5314 0.0128,12.7624 2.3358,14.3794 C4.6578,15.9964 8.5728,14.3884 10.8978,11.0494 C13.2228,7.7114 12.7868,2.0974 11.5078,1.2064"
            fill="#CBD62A"
          />
          <path
            d="M11.5078,1.2064 C10.2288,0.3154 4.8128,1.8544 2.4878,5.1934 C0.1638,8.5314 0.0128,12.7624 2.3358,14.3794 C4.6578,15.9964 8.5728,14.3884 10.8978,11.0494 C13.2228,7.7114 12.7868,2.0974 11.5078,1.2064"
            stroke="#575825"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g transform="translate(1407.000000, 847.000000)">
          <path
            d="M0.3594,1.3011 C-0.3726,2.1521 0.3324,6.1451 2.5534,8.0551 C4.7744,9.9651 7.7934,10.3831 9.1224,8.8381 C10.4514,7.2931 9.5864,4.3701 7.3654,2.4601 C5.1444,0.5501 1.0914,0.4501 0.3594,1.3011"
            fill="#A3C23A"
          />
          <path
            d="M0.3594,1.3011 C-0.3726,2.1521 0.3324,6.1451 2.5534,8.0551 C4.7744,9.9651 7.7934,10.3831 9.1224,8.8381 C10.4514,7.2931 9.5864,4.3701 7.3654,2.4601 C5.1444,0.5501 1.0914,0.4501 0.3594,1.3011"
            stroke="#575825"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g transform="translate(1418.000000, 851.000000)">
          <path d="M0.3354,5.3793 L4.2844,0.2603" />
          <path
            d="M0.3354,5.3793 L4.2844,0.2603"
            stroke="#575825"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g transform="translate(1412.000000, 853.000000)">
          <path d="M0.6421,0.0521 L4.1221,2.8381" />
          <path
            d="M0.6421,0.0521 L4.1221,2.8381"
            stroke="#575825"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          d="M1382,896 L1332,896"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1322,896 L1314,896"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1379,871.812301 C1378.46694,872.938162 1377.47671,873.935682 1376.17816,874.513742 C1373.69825,875.617692 1371.03201,874.778774 1370.22426,872.636611 C1369.41555,870.494448 1370.84952,867.913002 1373.63198,867"
          stroke="#D62793"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1382.55926,866.419142 C1382.9329,865.552315 1383.08758,864.524855 1382.95098,863.45136 C1382.60546,860.73824 1380.53237,858.75678 1378.32166,859.024174 C1376.11096,859.292548 1374.40548,861.424845 1375.19695,864.047855 C1375.81968,866.113549 1379.02877,868 1379.02877,868"
          stroke="#D62793"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <polygon
          fill="#FFFFFF"
          points="1400 849.198154 1373.42932 895 1368 891.800845 1394.57068 846"
        />
        <polygon
          stroke="#7350A0"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="1400 849.198154 1373.42932 895 1368 891.800845 1394.57068 846"
        />
        <polygon fill="#D62793" points="1414 898 1422 898 1422 858 1414 858" />
        <polygon
          fill="#D62793"
          points="1388 868.563033 1383.84237 875 1379 872.436967 1383.15763 866"
        />
      </g>
    </g>
  </svg>
);
